// store/modules/site.js
export default {
    namespaced: true,
    state: () => ({
        webInfo: {
            showList: ""
        },
        systemNotice: {},
        siteAccess: 0,
        visitorAccess: 0,
        searchDialogVisible: false,
        navBarDislogVisible: false, // 注意：原拼写错误（Dislog→Dialog），建议修正为navBarDialogVisible
        isCommentVisible: false
    }),
    getters: {
        getSiteAccess: (state) => state.siteAccess,
        getSystemNotice: (state) => state.systemNotice,
        getVsitorAccess: (state) => state.visitorAccess, // 注意：原拼写错误（Vsitor→Visitor）
        getWebInfo: (state) => state.webInfo,
        getSearchDialogVisible: (state) => state.searchDialogVisible,
        getNavBarDialogVisible: (state) => state.navBarDislogVisible,
        getIsCommentVisible: (state) => state.isCommentVisible
    },
    mutations: {
        SET_WEB_INFO(state, value) {
            state.webInfo = value
        },
        SET_SYSTEM_NOTICE(state, value) {
            state.systemNotice = value
        },
        SET_SITE_ACCESS(state, value) {
            state.siteAccess = value
        },
        SET_VISITOR_ACCESS(state, value) {
            state.visitorAccess = value
        },
        SET_SEARCH_DIALOG_VISIBLE(state, value) {
            state.searchDialogVisible = value
        },
        SET_NAVBAR_DIALOG_VISIBLE(state, value) {
            state.navBarDislogVisible = value
        },
        SET_IS_COMMENT_VISIBLE(state, value) {
            state.isCommentVisible = value
        }
    },
    actions: {}
}